import Switch from '@components/v2/form/Switch/Switch';
import { Stack } from '@mui/material';
import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import SettingContainer from '../../SettingContainer';
import { SalesRepresentativeSectionGeneralSettingsProps } from '../types/GeneralSettings.types';

const SalesRepresentativeSectionGeneralSettings = ({
  generalSettings,
  handleChangeAndBlur,
}: SalesRepresentativeSectionGeneralSettingsProps) => {
  const { translate } = useTranslation();

  return (
    <SettingContainer
      title={translate(LangEnum.GLOBAL_SALES_REPRESENTATIVE)}
      description={LangEnum.GENERAL_SETTINGS_SALES_REPRESENTATIVE_DESCRIPTION}
    >
      <Stack sx={{ gap: 2 }}>
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_ENABLE_PRICE_TABLE_BY_REPRESENTATIVE_LABEL)}
          name="enablePriceTableByRepresentative"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.enablePriceTableByRepresentative}
          testId="switch_general_settings_enable_price_table_by_representative"
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'enablePriceTableByRepresentative' })
          }
        />
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_ENABLE_CHANGE_ORDER_SALES_REP)}
          name="enableChangeOrderSalesRep"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.enableChangeOrderSalesRep}
          testId="switch_general_settings_enable_change_order_sales_rep"
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'enableChangeOrderSalesRep' })
          }
        />
        <Switch
          label={translate(LangEnum.GENERAL_SETTINGS_ENABLE_REP_VISIBILITY_BETWEEN_REPS)}
          name="enableRepVisibilityBetweenReps"
          size="medium"
          sx={{ ml: 0 }}
          checked={generalSettings.enableRepVisibilityBetweenReps}
          testId="switch_general_settings_enable_rep_visibility_between_reps"
          onChange={(_, checked) =>
            handleChangeAndBlur({ value: checked, name: 'enableRepVisibilityBetweenReps' })
          }
        />
      </Stack>
    </SettingContainer>
  );
};

export default SalesRepresentativeSectionGeneralSettings;
